import { render, staticRenderFns } from "./MainAccessInformation.vue?vue&type=template&id=2218a929"
import script from "./MainAccessInformation.vue?vue&type=script&lang=js"
export * from "./MainAccessInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports